import * as React from 'react';
import { Paper } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';

import { STATE } from 'app/constants';
import { createFormatters } from 'app/infrastructure/data/date';
import { DateFormatters } from 'app/infrastructure/data/types';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';

import { getAdminMessageAccess } from '../common/get-admin-message-access';
import { administrationMessagesTranslation } from '../constants';
import { AdministrationMessagesState } from '../types-store';
import { actionCreators } from './actions';
import { MessagesListRenderer } from './components/messages-list-renderer';

import styles from './messages-list.scss';
import { scrollToTop } from 'app/infrastructure/platform/routing';

export type MessagesListProps = DefaultContainerProps
  & AdministrationMessagesState
  & typeof actionCreators;

class MessagesListComponent extends React.PureComponent<MessagesListProps> {
  public static statePath: string = STATE.administrationMessages;

  private formatters: DateFormatters;

  public constructor(props: MessagesListProps) {
    super(props);

    this.formatters = createFormatters(props.sharedState.locale);
  }

  public componentDidMount() {
    const { list: { query, includeInactive }, loadMessages } = this.props;
    scrollToTop();

    loadMessages(query, includeInactive);
  }

  private updateQuery = (query: string) => {
    const { list: { query: prevQuery, includeInactive }, updateQuery, loadMessages } = this.props;

    if (query === prevQuery) {
      return;
    }

    updateQuery(query);

    if ((query || '').trim() !== (prevQuery || '').trim()) {
      loadMessages(query, includeInactive);
    }
  }

  private updateIncludeInactive = (includeInactive: boolean) => {
    const { list: { query, includeInactive: prevIncludeInactive }, updateIncludeInactive, loadMessages } = this.props;

    if (includeInactive === prevIncludeInactive) {
      return;
    }

    updateIncludeInactive(includeInactive);
    loadMessages(query, includeInactive);
  }

  private fetchMore = () => {

    const { list: { messages, numberOfResults, fetching, query, includeInactive }, loadMessages } = this.props;

    if (fetching || !messages || messages.length === 0 || messages.length === numberOfResults) {
      return;
    }

    loadMessages(query, includeInactive, messages.length);
  };

  public render() {

    const { list, updateMessage, deleteMessage, translation, sharedState } = this.props;
    const adminMessageAccess = getAdminMessageAccess(sharedState);

    return <div className="entity-view">
      <Paper componentId="code-base-paper" className={undefined}>
        <MainGridContainer className={styles.messagesHeader}>
          <MessagesListRenderer
            listState={list}
            canEdit={adminMessageAccess.edit}
            canDelete={adminMessageAccess.delete}
            updateMessage={updateMessage}
            deleteMessage={deleteMessage}
            fetchMore={this.fetchMore}
            updateQuery={this.updateQuery}
            updateIncludeInactive={this.updateIncludeInactive}
            translation={translation}
            formatters={this.formatters}
          />
        </MainGridContainer>
      </Paper>
    </div>;
  }
}

const container = containerFactory(MessagesListComponent, actionCreators, undefined, administrationMessagesTranslation);

export { container as AdministrationMessagesList };
